import {useMutation} from 'react-query';
import actions from '../api/colors';

const useFetchColorsWithBatchNumber = (colorsId: Array<number>) => {
  return useMutation('useFetchColorsWithBatchNumber', async () => {
    const colors = await actions.fetchColorsWithBatchNumber(colorsId);
    return colors;
  }, {retry: false});
};

export default useFetchColorsWithBatchNumber;
